import clsx from 'clsx';
import React from 'react';

import FlexLink from '@components/FlexLink';
import { topic_landing_path } from '@routes';

import { ANCHOR_LINK_CLASSES } from '.';

const TOPICS = [
  {
    title: 'Venture Capital',
    link: topic_landing_path('venture-capital'),
  },
  {
    title: 'Markets',
    link: topic_landing_path('markets'),
  },
  {
    title: 'Crypto',
    link: topic_landing_path('crypto'),
  },
  {
    title: 'Private Equity',
    link: topic_landing_path('private-equity'),
  },
  {
    title: 'Fintech',
    link: topic_landing_path('fintech'),
  },
  {
    title: 'Finance',
    link: topic_landing_path('finance'),
  },
];
const WhatWeCover = () => (
  <section className="mb-48 flex justify-center border-0 border-b border-t border-solid border-grayscale-beige py-24 md:mb-64">
    <div className="flex flex-col items-center justify-center gap-24 sm:flex-row sm:justify-start">
      <h2 className="w-auto font-suisse-intl-mono text-overline-sm text-grayscale-gray">
        What We Cover:
      </h2>
      <div className="flex flex-wrap items-center justify-center gap-x-48 gap-y-32 sm:justify-start sm:gap-32 lg:gap-48">
        {TOPICS.map((topic) => (
          <FlexLink
            key={topic.title}
            href={topic.link}
            className={clsx(
              'font-suisse-intl text-button-sm text-grayscale-charcoal ',
              ANCHOR_LINK_CLASSES
            )}
          >
            {topic.title}
          </FlexLink>
        ))}
      </div>
    </div>
  </section>
);

export default WhatWeCover;
